import {APIService} from "../../common/APIService";
import {VcaPlan} from "../../dto/VcaPlan";

export class VcaPlanService extends APIService {
  public async browse(projectId: string) {
    const json = await this.getJson<{ data: object[] }>(`projects/${projectId}/vca-plans`)
    return json.data.map(item => VcaPlan.fromJson(item))
  }

  public async add(projectId: string, file: File) {
    const formData = new FormData();
    formData.append('file', file, file.name)
    const json = await this.postForm<{ data: object }>(`projects/${projectId}/vca-plans`, formData)
    return VcaPlan.fromJson(json.data)
  }

  public async delete(projectId: string, vcaPlanId: string) {
    await this.deleteJson(`projects/${projectId}/vca-plans/${vcaPlanId}`)
  }

  public async download(projectId: string, vcaPlanId: string): Promise<Blob> {
    const response = await this.getRaw(`projects/${projectId}/vca-plans/${vcaPlanId}/download`)
    return await response.blob()
  }
}
